<div class="inspiration-wrapper">
  <div class="inspiration-header">
    <span class="casto-title large" [innerHTML]="'need_mapping.title'|translate"></span>
    <div class="actions-container" style="margin-bottom: 0;">
      @if (this.current.vendor) {
        <ng-casto-button
          [label]="'need_mapping.skip' | translate"
          class="secondary"
          (click)="start()"></ng-casto-button>
      } @else {
        <ng-casto-button
          [label]="'need_mapping.skip' | translate"
          class="secondary"
          [routerLink]="['/cuisine/configuration']"></ng-casto-button>
      }
    </div>
  </div>
  <div class="inspiration-container">
    <div class="tablist-container">
      <ul class="tablist">
        <li [class.clickable]="true"
            [class.active]="currentTabId === 1">
          <button
            (click)="currentTabId = 1"
            [class.clickable]="true"
            [class.active]="currentTabId === 1"
            type="button">
            <span>{{ 'need_mapping.steps.title_1_short' | translate }}</span>
          </button>
        </li>
        <li [class.clickable]="current.kitchen.modelId > -1"
            [class.active]="currentTabId === 2">
          <button
            (click)="currentTabId = 2"
            [class.clickable]="current.kitchen.modelId > -1"
            [class.active]="currentTabId === 2"
            type="button">
            <span>{{ 'need_mapping.steps.title_2_short' | translate }}</span>
          </button>
        </li>
        <li [class.clickable]="current.kitchen.layoutRef != null"
            [class.active]="currentTabId === 3">
          <button
            (click)="currentTabId = 3"
            [class.clickable]="current.kitchen.layoutRef != null"
            [class.active]="currentTabId === 3"
            type="button">
            <span>{{ 'need_mapping.steps.title_3_short' | translate }}</span>
          </button>
        </li>
        <li [class.clickable]="current.kitchen.ovenConfigurationRef != null"
            [class.active]="currentTabId === 4">
          <button
            (click)="currentTabId = 4"
            [class.clickable]="current.kitchen.ovenConfigurationRef != null"
            [class.active]="currentTabId === 4"
            type="button">
            <span>{{ 'need_mapping.steps.title_4_short' | translate }}</span>
          </button>
        </li>
        <li [class.clickable]="current.kitchen.fridgeConfigurationRef != null"
            [class.active]="currentTabId === 5">
          <button
            (click)="currentTabId = 5"
            [class.clickable]="current.kitchen.fridgeConfigurationRef != null"
            [class.active]="currentTabId === 5"
            type="button">
            <span>{{ 'need_mapping.steps.title_5_short' | translate }}</span>
          </button>
        </li>
        <li [class.clickable]="true"
            [class.active]="currentTabId === 6">
          <button
            (click)="currentTabId = 6"
            [class.clickable]="true"
            [class.active]="currentTabId === 6"
            type="button">
            <span>{{ 'need_mapping.steps.title_6' | translate }}</span>
          </button>
        </li>
      </ul>
    </div>
    <div class="inspiration-choice-container">
      <ng-container [ngSwitch]="currentTabId">
        <ng-casto-kitchen-style *ngSwitchCase="1" (onComplete)="nextTab()"></ng-casto-kitchen-style>
        <ng-casto-kitchen-model *ngSwitchCase="2" (onComplete)="nextTab()"></ng-casto-kitchen-model>
        <ng-casto-kitchen-layout *ngSwitchCase="3" (onComplete)="nextTab()"></ng-casto-kitchen-layout>
        <ng-casto-kitchen-oven *ngSwitchCase="4" (onComplete)="nextTab()"></ng-casto-kitchen-oven>
        <ng-casto-kitchen-fridge *ngSwitchCase="5" (onComplete)="nextTab()"></ng-casto-kitchen-fridge>
        <ng-casto-kitchen-recap *ngSwitchCase="6" (onBackToStep)="currentTabId = $event"></ng-casto-kitchen-recap>
      </ng-container>
    </div>
  </div>
</div>



